import { Box, Typography } from "@mui/material";
import { colors } from "../../../../styles/Variables";

const CashbackIntro = () => {
    return (
        <Box
        sx={{
            px: 2,
            py: 6,
            maxWidth: 600,
            mx: "auto",
            textAlign: "center",
            position: "relative",
        }}
        >
        <Box
            component="img"
            src="https://static.meucupom.com/media/LP%20-%20Devolve/Moedas.png"
            alt=""
            aria-hidden="true"
            sx={{
            position: "absolute",
            top: 0,
            right: { xs: -10, md: -60 },
            width: { xs: 60, md: 90 },
            }}
        />

        <Typography
            variant="h6"
            sx={{
            fontWeight: "bold",
            color: colors.darkBlue,
            mb: 3,
            fontSize: { xs: "1rem", md: "1.5rem" },
            }}
        >
            Você sabia que pode ganhar de volta parte do valor de suas compras?
        </Typography>

        <Typography
            component="p"
            sx={{
            color: colors.darkBlue,
            fontSize: { xs: "1rem", md: "1.2rem" },
            lineHeight: 1.8,
            mb: 2,
            textAlign: "justify",
            }}
        >
            O cashback é uma modalidade de reembolso em que uma porcentagem do
            valor gasto é devolvida ao cliente. Com o{" "}
            <Box component="span" sx={{ color: colors.purple, fontWeight: "bold" }}>
            MeuCupom Devolve
            </Box>
            , você ganha cashback direto na conta ao realizar compras online em
            diversas lojas parceiras do{" "}
            <Box component="span" sx={{ color: colors.purple, fontWeight: "bold" }}>
            MeuCupom
            </Box>
            .
        </Typography>

        <Typography component="p"
            sx={{
            color: colors.darkBlue,
            fontSize: { xs: "1rem", md: "1.2rem" },
            lineHeight: 1.8,
            mb: 4,
            textAlign: "justify",
            }}
        >
            É uma ótima forma de economizar em dobro e aproveitar descontos exclusivos.
        </Typography>

        <Typography sx={{ fontWeight: "bold",  color: colors.purple, fontSize: { xs: "1rem", md: "1.3rem" },}}>
            Curtiu?
        </Typography>

        <Typography sx={{ fontWeight: "bold", color: colors.purple, fontSize: { xs: "1rem", md: "1.3rem" },}}>
            Então vem conferir como funciona:
        </Typography>
        </Box>
    );
};

export default CashbackIntro;
